module.exports = __webpack_public_path__ + "static/media/rst-logo.be1cfc2e.svg";